import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { Grid, Divider } from '@material-ui/core';
import BackArrowLogo from '../../../assets/back_arrow.png';

import MobileConnectSocialMedia from '../forms/MobileConnectSocialMedia';

class Social extends React.Component {

  componentDidMount() {}

  async submitForm() {
    await this.personalDetailForm.submitForm();
  }

  render() {
    return (
      <Grid container style={{ backgroundColor: 'white' }}>
        <Grid
          container
          style={{
            border: '1px solid #DCDCDC',
            padding: '15px',
            width: '100%',
          }}
        >
          <Grid item md={12}>
            <Grid
              container
              // spacing={12}
              direction="row"
              alignItems="center"
              style={{
                justifyContent: 'space-between',
              }}
            >
              <Grid item md={12}>
                <NavLink
                  to="/influencer/settings"
                  style={{
                    textDecoration: 'none',
                    lineHeight: '17px',
                    margin: '5px',
                    color: 'black',
                  }}
                >
                  <span>
                    <img alt="" src={BackArrowLogo} style={{ width: 20 }} />
                  </span>
                  &nbsp;&nbsp;
                  <span
                    style={{
                      fontSize: 15,
                    }}
                  >
                    Social Settings
                  </span>
                </NavLink>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={5}>
                <Divider
                  style={{
                    background:
                      'linear-gradient(90deg, rgba(171,171,171,1) 0%, rgba(176,176,176,0) 100%)',
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container style={{ paddingLeft: 16, paddingRight: 16, marginTop: 16 }}>
          <Grid item md={12} style={{ width: '100%' }}>
            <div className="inf-hero">
              <div className="inf-hero-inner">
                <p className="inf-hero-kicker">Account</p>
                <h1 className="inf-hero-title">Connected Accounts</h1>
                <p className="inf-hero-sub">Link your Instagram and YouTube.</p>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            marginBottom: 30,
            paddingLeft: 16,
            paddingRight: 16,
          }}
        >
          <Grid item md={5}>
            <Divider
              style={{
                background:
                  'linear-gradient(90deg, rgba(171,171,171,1) 0%, rgba(176,176,176,0) 100%)',
              }}
            />
          </Grid>
        </Grid>
        <Grid container style={{ paddingLeft: 16, paddingRight: 16 }}>
          <Grid item md={12} style={{ width: '100%' }}>
            <MobileConnectSocialMedia />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(Social);
